module.exports = __webpack_public_path__ + "dist/media/logo--nl.ff6e80e5.svg";